import { render, staticRenderFns } from "./InvoiceDetail.vue?vue&type=template&id=3b8ba4d8&scoped=true&"
import script from "./InvoiceDetail.vue?vue&type=script&lang=ts&"
export * from "./InvoiceDetail.vue?vue&type=script&lang=ts&"
import style0 from "./InvoiceDetail.vue?vue&type=style&index=0&id=3b8ba4d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8ba4d8",
  null
  
)

export default component.exports